import { Action } from '@ngrx/store';
import {
    EMPLOYEES_FETCH,
    EMPLOYEE_VIEWED_SET,
    EMPLOYEE_CREATE,
    EMPLOYEE_FETCH,
    EMPLOYEE_EXCLUDE,
    EMPLOYEE_PAYSTUBS_FETCH,
    EMPLOYEE_PAYSTUBS_RELATION_SET,
    EMPLOYEE_PAYSTUB_DOWNLOAD,
    EMPLOYEE_PAYSTUBS_FETCH_MORE,
    EMPLOYEE_PAYSTUBS_MORE_RELATION_SET,
    EMPLOYEE_DOCUMENTS_FETCH,
    EMPLOYEE_DOCUMENTS_FETCH_MORE,
    EMPLOYEE_DOCUMENTS_RELATION_SET,
    EMPLOYEE_DOCUMENTS_MORE_RELATION_SET,
    EMPLOYEE_DOCUMENT_DOWNLOAD,
    EMPLOYEE_BENEFITS_FETCH,
    EMPLOYEE_BENEFITS_FETCH_MORE,
    EMPLOYEE_BENEFITS_RELATION_SET,
    EMPLOYEE_BENEFITS_MORE_RELATION_SET,
    EMPLOYEE_DEDUCTIONS_FETCH,
    EMPLOYEE_DEDUCTIONS_FETCH_MORE,
    EMPLOYEE_DEDUCTIONS_MORE_RELATION_SET,
    EMPLOYEE_DEDUCTIONS_RELATION_SET,
    EMPLOYEE_BENEFITS_MANAGEMENT_LAUNCH,
    EMPLOYEE_DEDUCTIONS_MANAGEMENT_LAUNCH,
    EMPLOYEE_PATCH,
    EMPLOYEE_UPDATE,
    EMPLOYEE_INVITE,
    EMPLOYEE_RESTART,
    EMPLOYEE_TERMINATE,
    EMPLOYEE_WAGE_UPDATE,
    EMPLOYEE_WAGE_DELETE_PENDING,
    EMPLOYEE_WAGES_FETCH,
    EMPLOYEE_WAGES_RELATION_SET,
    EMPLOYEES_PATCH,
    EMPLOYEE_LEAVE_BALANCE_UPDATE,
    EMPLOYEES_LEAVE_BALANCE_REPORT_DOWNLOAD
} from '../action-types';
import {
    ListItemSetAction,
    ListItemUnsetAction,
    ListItemUnsetAllAction,
    ListMergeAction,
    ListSetAction,
    ListSetFetchingAction,
    ListSetFetchingMoreAction
} from '../shared/list/list.actions';
import { SharedAction } from '../shared/actions/shared-action';
import { GROUP_EMPLOYEES, GROUP_EMPLOYEE_BENEFITS, GROUP_EMPLOYEE_DEDUCTIONS, GROUP_EMPLOYEE_DOCUMENTS, GROUP_EMPLOYEE_PAYSTUBS, GROUP_EMPLOYEE_SUGGESTIONS, GROUP_EMPLOYEE_WAGES } from '../state-groups';
import { EMPLOYEE_BENEFIT_ENTITY, EMPLOYEE_DEDUCTION_ENTITY, EMPLOYEE_DOCUMENT_ENTITY, EMPLOYEE_ENTITY, EMPLOYEE_PAYSTUB_ENTITY, EMPLOYEE_WAGE_ENTITY } from '../entity-types';
import { CreateEmployeeRequest } from '@core/models/employee/create-employee-request';
import { ObservableAction } from '../shared/actions/observable-action';
import { PatchEmployeeRequest } from '@core/models/employee/patch-employee-request';
import { EditEmployeeRequest } from '@core/models/employee/edit-employee-request';
import { EmployeeWageUpdateRequest } from '@core/models/employee/employee-wage-update-request';
import { EmployeeLeaveBalanceUpdateRequest } from '@core/models/employee/employee-leave-balance-update.request';

export class FetchEmployeesAction implements Action {
    readonly type = EMPLOYEES_FETCH;

    constructor(
        public payload?: {
            active?: boolean,
            leave_balances?: boolean
            policies?: boolean
        }
    ) {}
}

export class SetEmployeesAction extends ListSetAction implements Action {
    name = GROUP_EMPLOYEES;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_ENTITY;
    }
}

export class MergeEmployeesAction extends ListMergeAction implements SharedAction {
    name = GROUP_EMPLOYEES;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_ENTITY;
    }
}

export class SetEmployeesFetchingAction
    extends ListSetFetchingAction
    implements SharedAction {
    name = GROUP_EMPLOYEES;

    constructor(payload: any) {
        super(payload);
    }
}

export class SetEmployeeAction extends ListItemSetAction implements SharedAction {
    name = GROUP_EMPLOYEES;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_ENTITY;
    }
}

export class UnsetEmployeeAction extends ListItemUnsetAction implements SharedAction {
    name = GROUP_EMPLOYEES;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_ENTITY;
    }
}

@ObservableAction()
export class SendEmployeeInvitationAction implements Action {
    readonly type = EMPLOYEE_INVITE;

    constructor(public payload: { id: string }) {}
}

export class ResetEmployeesAction extends ListItemUnsetAllAction implements SharedAction {
    name = GROUP_EMPLOYEES;

    constructor() {
        super({ domain: EMPLOYEE_ENTITY });
    }
}

@ObservableAction()
export class CreateEmployeeAction implements Action {
    readonly type = EMPLOYEE_CREATE;

    constructor(public payload: CreateEmployeeRequest) {}
}

@ObservableAction()
export class UpdateEmployeeAction implements Action {
    readonly type = EMPLOYEE_UPDATE;

    constructor(public payload: EditEmployeeRequest) {}
}

@ObservableAction()
export class UpdateEmployeeWageAction implements Action {
    readonly type = EMPLOYEE_WAGE_UPDATE;

    constructor(public payload: {
        id: string,
        request: EmployeeWageUpdateRequest
    }) {}
}

@ObservableAction()
export class DeletePendingEmployeeWageAction implements Action {
    readonly type = EMPLOYEE_WAGE_DELETE_PENDING;

    constructor(public payload: { id: string }) {}
}

@ObservableAction()
export class PatchEmployeeAction implements Action {
    readonly type = EMPLOYEE_PATCH;

    constructor(public payload: PatchEmployeeRequest) {}
}

@ObservableAction()
export class PatchEmployeesAction implements Action {
    readonly type = EMPLOYEES_PATCH;

    constructor(public payload: {
        employees: PatchEmployeeRequest[]
    }) {}
}

@ObservableAction()
export class ExcludeEmployeeAction implements Action {
    readonly type = EMPLOYEE_EXCLUDE;

    constructor(public payload: { id: string }) {}
}

@ObservableAction()
export class RestartEmployeeAction implements Action {
    readonly type = EMPLOYEE_RESTART;

    constructor(public payload: {
        id: string,
        startDate: string
    }) {}
}

@ObservableAction()
export class TerminateEmployeeAction implements Action {
    readonly type = EMPLOYEE_TERMINATE;

    constructor(public payload: {
        id: string,
        terminationDate: string
    }) {}
}

export class SetViewedEmployeeAction implements Action {
    readonly type = EMPLOYEE_VIEWED_SET;

    constructor(
        public payload: {
            id: string;
        }
    ) {}
}

export class FetchEmployeeAction implements Action {
    readonly type = EMPLOYEE_FETCH;

    constructor(public payload: { id: string }) {}
}

export class FetchEmployeePaystubsAction implements Action {
    readonly type = EMPLOYEE_PAYSTUBS_FETCH;

    constructor(public payload: { id: string }) {}
}

export class FetchMoreEmployeePaystubsAction implements Action {
    readonly type = EMPLOYEE_PAYSTUBS_FETCH_MORE;
}

export class SetEmployeePaystubsFetchingMoreAction extends ListSetFetchingMoreAction implements SharedAction {
    name = GROUP_EMPLOYEE_PAYSTUBS;

    constructor(payload: any) {
        super(payload);
    }
}

export class SetEmployeePaystubsAction extends ListSetAction implements SharedAction {
    name = GROUP_EMPLOYEE_PAYSTUBS;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_PAYSTUB_ENTITY;
    }
}

export class MergeEmployeePaystubsAction extends ListMergeAction implements SharedAction {
    name = GROUP_EMPLOYEE_PAYSTUBS;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_PAYSTUB_ENTITY;
    }
}

export class SetEmployeePaystubsRelationshipAction implements Action {
    readonly type  = EMPLOYEE_PAYSTUBS_RELATION_SET;
  
    constructor(public payload: {
      itemIds: string[],
      relatedId: string
    }) {}
}

export class SetMoreEmployeePaystubsRelationshipAction implements Action {
    readonly type  = EMPLOYEE_PAYSTUBS_MORE_RELATION_SET;
  
    constructor(public payload: {
      itemIds: string[],
      relatedId: string
    }) {}
}

export class SetEmployeePaystubsFetchingAction
    extends ListSetFetchingAction
    implements SharedAction {
    name = GROUP_EMPLOYEE_PAYSTUBS;

    constructor(payload: any) {
        super(payload);
    }
}

@ObservableAction()
export class DownloadEmployeePaystubAction implements Action {
    readonly type = EMPLOYEE_PAYSTUB_DOWNLOAD;

    constructor(public payload: { id: string, paystubId: string }) {}
}

export class FetchEmployeeDocumentsAction implements Action {
    readonly type = EMPLOYEE_DOCUMENTS_FETCH;

    constructor(public payload: { id: string }) {}
}

export class FetchMoreEmployeeDocumentsAction implements Action {
    readonly type = EMPLOYEE_DOCUMENTS_FETCH_MORE;
}

export class SetEmployeeDocumentsFetchingMoreAction extends ListSetFetchingMoreAction implements SharedAction {
    name = GROUP_EMPLOYEE_DOCUMENTS;

    constructor(payload: any) {
        super(payload);
    }
}

export class SetEmployeeDocumentsAction extends ListSetAction implements SharedAction {
    name = GROUP_EMPLOYEE_DOCUMENTS;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_DOCUMENT_ENTITY;
    }
}

export class MergeEmployeeDocumentsAction extends ListMergeAction implements SharedAction {
    name = GROUP_EMPLOYEE_DOCUMENTS;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_DOCUMENT_ENTITY;
    }
}

export class SetEmployeeDocumentsRelationshipAction implements Action {
    readonly type  = EMPLOYEE_DOCUMENTS_RELATION_SET;
  
    constructor(public payload: {
      itemIds: string[],
      relatedId: string
    }) {}
}

export class SetMoreEmployeeDocumentsRelationshipAction implements Action {
    readonly type  = EMPLOYEE_DOCUMENTS_MORE_RELATION_SET;
  
    constructor(public payload: {
      itemIds: string[],
      relatedId: string
    }) {}
}

export class SetEmployeeDocumentsFetchingAction
    extends ListSetFetchingAction
    implements SharedAction {
    name = GROUP_EMPLOYEE_DOCUMENTS;

    constructor(payload: any) {
        super(payload);
    }
}

@ObservableAction()
export class DownloadEmployeeDocumentAction implements Action {
    readonly type = EMPLOYEE_DOCUMENT_DOWNLOAD;

    constructor(public payload: { id: string, documentId: string }) {}
}

// Benefits
export class FetchEmployeeBenefitsAction implements Action {
    readonly type = EMPLOYEE_BENEFITS_FETCH;

    constructor(public payload: { id: string }) {}
}

export class FetchMoreEmployeeBenefitsAction implements Action {
    readonly type = EMPLOYEE_BENEFITS_FETCH_MORE;
}

export class SetEmployeeBenefitsFetchingMoreAction extends ListSetFetchingMoreAction implements SharedAction {
    name = GROUP_EMPLOYEE_BENEFITS;

    constructor(payload: any) {
        super(payload);
    }
}

export class SetEmployeeBenefitsAction extends ListSetAction implements SharedAction {
    name = GROUP_EMPLOYEE_BENEFITS;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_BENEFIT_ENTITY;
    }
}

export class MergeEmployeeBenefitsAction extends ListMergeAction implements SharedAction {
    name = GROUP_EMPLOYEE_BENEFITS;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_BENEFIT_ENTITY;
    }
}

export class SetEmployeeBenefitsRelationshipAction implements Action {
    readonly type  = EMPLOYEE_BENEFITS_RELATION_SET;
  
    constructor(public payload: {
      itemIds: string[],
      relatedId: string
    }) {}
}

export class SetMoreEmployeeBenefitsRelationshipAction implements Action {
    readonly type  = EMPLOYEE_BENEFITS_MORE_RELATION_SET;
  
    constructor(public payload: {
      itemIds: string[],
      relatedId: string
    }) {}
}

export class SetEmployeeBenefitsFetchingAction
    extends ListSetFetchingAction
    implements SharedAction {
    name = GROUP_EMPLOYEE_BENEFITS;

    constructor(payload: any) {
        super(payload);
    }
}

@ObservableAction()
export class LaunchEmployeeBenefitsManagementAction implements Action {
    readonly type = EMPLOYEE_BENEFITS_MANAGEMENT_LAUNCH;

    constructor(public payload: { id: string }) {}
}

// Deductions
export class FetchEmployeeDeductionsAction implements Action {
    readonly type = EMPLOYEE_DEDUCTIONS_FETCH;

    constructor(public payload: { id: string }) {}
}

export class FetchMoreEmployeeDeductionsAction implements Action {
    readonly type = EMPLOYEE_DEDUCTIONS_FETCH_MORE;
}

export class SetEmployeeDeductionsFetchingMoreAction extends ListSetFetchingMoreAction implements SharedAction {
    name = GROUP_EMPLOYEE_DEDUCTIONS;

    constructor(payload: any) {
        super(payload);
    }
}

export class SetEmployeeDeductionsAction extends ListSetAction implements SharedAction {
    name = GROUP_EMPLOYEE_DEDUCTIONS;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_DEDUCTION_ENTITY;
    }
}

export class MergeEmployeeDeductionsAction extends ListMergeAction implements SharedAction {
    name = GROUP_EMPLOYEE_DEDUCTIONS;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_DEDUCTION_ENTITY;
    }
}

export class SetEmployeeDeductionsRelationshipAction implements Action {
    readonly type  = EMPLOYEE_DEDUCTIONS_RELATION_SET;
  
    constructor(public payload: {
      itemIds: string[],
      relatedId: string
    }) {}
}

export class SetMoreEmployeeDeductionsRelationshipAction implements Action {
    readonly type  = EMPLOYEE_DEDUCTIONS_MORE_RELATION_SET;
  
    constructor(public payload: {
      itemIds: string[],
      relatedId: string
    }) {}
}

export class SetEmployeeDeductionsFetchingAction
    extends ListSetFetchingAction
    implements SharedAction {
    name = GROUP_EMPLOYEE_DEDUCTIONS;

    constructor(payload: any) {
        super(payload);
    }
}

@ObservableAction()
export class LaunchEmployeeDeductionsManagementAction implements Action {
    readonly type = EMPLOYEE_DEDUCTIONS_MANAGEMENT_LAUNCH;

    constructor(public payload: { id: string }) {}
}

// Wages
export class FetchEmployeeWagesAction implements Action {
    readonly type = EMPLOYEE_WAGES_FETCH;

    constructor(public payload: { id: string }) {}
}

export class SetEmployeeWagesFetchingAction extends ListSetFetchingAction implements SharedAction {
    name = GROUP_EMPLOYEE_WAGES;

    constructor(payload: any) {
        super(payload);
    }
}

export class SetEmployeeWagesAction extends ListSetAction implements SharedAction {
    name = GROUP_EMPLOYEE_WAGES;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_WAGE_ENTITY;
    }
}

export class SetEmployeeWagesRelationshipAction implements Action {
    readonly type  = EMPLOYEE_WAGES_RELATION_SET;
  
    constructor(public payload: {
      itemIds: string[],
      relatedId: string
    }) {}
}

@ObservableAction()
export class UpdateEmployeeLeaveBalanceAction implements Action {
    readonly type = EMPLOYEE_LEAVE_BALANCE_UPDATE;

    constructor(public payload: {
        id: string,
        timeoffCode: string,
        request: EmployeeLeaveBalanceUpdateRequest
    }) {}
}

@ObservableAction()
export class DownloadEmployeesLeaveBalancesReportAction implements Action {
    readonly type = EMPLOYEES_LEAVE_BALANCE_REPORT_DOWNLOAD;

    constructor() {}
}
